require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-update-intldaypersonswithdisabilities-2018.json") })
        }
      }, "path---en-us-update-intldaypersonswithdisabilities-2018");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-update-intldaypersonswithdisabilities-2018!./.cache/json/en-us-update-intldaypersonswithdisabilities-2018.json
// module id = 761
// module chunks = 231608221292675